import { Modal } from "../Modal/Modal"
import { ReactNode } from "react"
import { ButtonSecondary } from "components/ui/buttons/ButtonSecondary/ButtonSecondary"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import style from "./ConfigurationModal.module.scss"
import { BottomBar } from "components/ui/bottomBar/BottomBar"

const { configurationModal, bar, button } = style

type Props = {
	children: ReactNode
	setModalClose: () => void
	isModalOpen: boolean
	saveHandle: () => void
	submitButtonText: string
}

export const ConfigurationModal = ({ children, isModalOpen, setModalClose, saveHandle, submitButtonText }: Props) => {
	return (
		<Modal width="100%" isModalOpen={isModalOpen} setModalClose={setModalClose} className="configurationModal">
			<div className={configurationModal} data-testid="modal-configuration">
				{children}
				<BottomBar className={bar}>
					<ButtonSecondary className={button} onClick={setModalClose}>
						Cancel
					</ButtonSecondary>
					<ButtonPrimary className={button} onClick={saveHandle}>
						{submitButtonText}
					</ButtonPrimary>
				</BottomBar>
			</div>
		</Modal>
	)
}
